<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align:center">The beauty of this story comes from a magical day worth telling about in some other account. I dedicate <em>Diamond in the Unknown</em> to everyone who reads it, likes it and talks about it.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?249316ea